import React from "react";
import styled from "styled-components";
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";

export default function TermsPage({ navigate }) {
  return (
    <>
      <TopNavbar navigate={navigate} currentPage="" />
      <PageHero className="pageHero">
        <div className="container">
          <h1 className="font40 extraBold darkColor heroTitle">תנאי שימוש</h1>
          <p className="font15 darkColor" style={{ marginTop: "10px", opacity: 0.9 }}>
            עודכן לאחרונה: 23.10.2026
          </p>
        </div>
      </PageHero>

      <PageBody>
        <div className="container">
          <Section>
            <h2 className="font25 extraBold darkColor">1. כללי</h2>
            <BodyText>
              ברוכה הבאה לאתר הלב הצבעוני (להלן: "האתר"). השימוש באתר מהווה הסכמה לתנאי
              השימוש המפורטים להלן. אם אינך מסכימה לתנאים אלו, אנא הימנעי משימוש באתר.
            </BodyText>
            <BodyText style={{ marginTop: "12px" }}>
              {/* TEXT PLACEHOLDER — replace with your real details */}
              האתר מופעל על ידי: <strong>שם מלא / שם עסק</strong>,
              ת"ז / ח"פ: <strong>_________</strong>,
              כתובת: <strong>_________</strong>.
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">2. קניין רוחני</h2>
            <BodyText>
              כל התכנים המופיעים באתר, לרבות טקסטים, תמונות, עיצוב, לוגו, שם המותג
              "הלב הצבעוני" ותכני הסדנאות, הם רכושה הבלעדי של בעלת האתר ומוגנים בזכויות
              יוצרים לפי חוק זכות יוצרים, תשס"ח–2007.
            </BodyText>
            <BodyText style={{ marginTop: "12px" }}>
              <strong>אסור</strong> להעתיק, לשכפל, להפיץ, לפרסם או להשתמש בתכנים
              ללא אישור מפורש ובכתב.
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">3. שימוש מותר באתר</h2>
            <BodyText>את רשאית:</BodyText>
            <List>
              <li>לעיין בתכני האתר לצורך אישי בלבד.</li>
              <li>ליצור קשר דרך הטפסים המיועדים לכך.</li>
              <li>להירשם לסדנאות המפורסמות באתר.</li>
            </List>
            <BodyText style={{ marginTop: "12px" }}>את <strong>אינה</strong> רשאית:</BodyText>
            <List>
              <li>להשתמש בתכנים למטרות מסחריות ללא אישור.</li>
              <li>להכניס תכנים פוגעניים, כוזבים או בלתי חוקיים.</li>
              <li>לפגוע בתפקוד האתר או בשרתים שלו.</li>
            </List>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">4. הרשמה לסדנאות ורכישות</h2>
            <BodyText>
              ההרשמה לסדנאות מתבצעת דרך טופס יצירת הקשר. ייתכן שתידרשי לאשר
              רכישה בערוץ נפרד (טלפון / העברה בנקאית / תשלום דיגיטלי).
            </BodyText>
            <BodyText style={{ marginTop: "12px" }}>
              <strong>מדיניות ביטול:</strong>
            </BodyText>
            <List>
              {/* TEXT PLACEHOLDER — adjust cancellation policy to your terms */}
              <li>ביטול עד <strong>__ ימים</strong> לפני מועד הסדנה: החזר מלא.</li>
              <li>ביטול בין <strong>__</strong> ל-<strong>__</strong> ימים לפני: החזר של __% מהתשלום.</li>
              <li>ביטול פחות מ-__ ימים לפני: לא יינתן החזר כספי, אך ניתן להעביר את המקום לאחרת.</li>
              <li>במקרה של ביטול מצד המארגנת: תינתן הודעה מוקדמת והחזר מלא.</li>
            </List>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">5. הגבלת אחריות</h2>
            <BodyText>
              האתר וכל תכניו מסופקים "כמות שהם" (As Is). בעלת האתר אינה אחראית לנזקים
              ישירים, עקיפים או תוצאתיים הנובעים משימוש באתר, לרבות:
            </BodyText>
            <List>
              <li>שגיאות, אי-דיוקים או הפסקות בשירות.</li>
              <li>קישורים חיצוניים: אחריותם על מפעיליהם בלבד.</li>
              <li>תקלות טכניות שאינן בשליטת בעלת האתר.</li>
            </List>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">6. קישורים חיצוניים</h2>
            <BodyText>
              האתר עשוי להכיל קישורים לאתרי צד שלישי (כגון רשתות חברתיות). קישורים
              אלו מסופקים לנוחיותך בלבד. בעלת האתר אינה אחראית לתכנים, מדיניות
              הפרטיות או שיטות הפעולה של אתרים אלו.
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">7. שינויים בתנאים</h2>
            <BodyText>
              בעלת האתר שומרת לעצמה את הזכות לעדכן תנאים אלו בכל עת. שינויים
              יפורסמו בעמוד זה. המשך השימוש באתר לאחר עדכון התנאים מהווה הסכמה לשינויים.
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">8. דין וסמכות שיפוט</h2>
            <BodyText>
              תנאי שימוש אלו כפופים לדיני מדינת ישראל. כל סכסוך הנובע משימוש באתר
              יידון בבתי המשפט המוסמכים במחוז {/* TEXT PLACEHOLDER */}<strong>_____</strong>, ישראל.
            </BodyText>
          </Section>

          <Divider />

          <Section>
            <h2 className="font25 extraBold darkColor">9. יצירת קשר</h2>
            <BodyText>
              לכל שאלה בנוגע לתנאי שימוש אלו:{" "}
              {/* TEXT PLACEHOLDER */}
              <strong>carmela0208@gmail.com</strong>
            </BodyText>
          </Section>

          <BackBtn onClick={() => navigate("home")} className="pinkBg whiteColor radius8 pointer semiBold font15">
            חזרה לדף הבית
          </BackBtn>
        </div>
      </PageBody>

      <Footer navigate={navigate} />
    </>
  );
}

const PageHero = styled.section`
  padding: 120px 0 40px;
  direction: rtl;
`;
const PageBody = styled.div`
  padding: 60px 0 80px;
  direction: rtl;
`;
const Section = styled.div`
  margin-bottom: 10px;
`;
const BodyText = styled.p`
  margin-top: 12px;
  line-height: 1.9;
  color: var(--ink-soft);
  font-size: 0.938rem;
`;
const List = styled.ul`
  list-style: disc;
  padding-right: 24px;
  margin-top: 12px;
  li {
    margin-bottom: 8px;
    line-height: 1.8;
    color: var(--ink-soft);
    font-size: 0.938rem;
  }
`;
const Divider = styled.hr`
  border: none;
  border-top: 1px solid var(--rose-200);
  margin: 30px 0;
`;
const BackBtn = styled.button`
  margin-top: 40px;
  padding: 14px 30px;
  font-size: 1rem;
  border: none;
  cursor: pointer;
`;
